// extracted by mini-css-extract-plugin
export default {"backButton":"PartyHistoryPage_backButton__SM4AH","backIcon":"PartyHistoryPage_backIcon__WtraP"};